<template>
    <div>
        <div class="dw-user-box">
            <div class="u-img"><img :src="employee.avatar_url" ></div>
            <div class="u-text">
                <h4 class="m-0" style="width: 150px"><img style="width: 17px;vertical-align: text-top;" src="@/assets/svg/girl.svg"> {{employee.name}}</h4>
                <el-select
                        v-model="section_id"
                        align="right"
                        style="width: 120px"
                        placeholder="校区">
                    <el-option
                            v-for="item in sections"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>

        </div>
        <template v-if="showPasswordBox">
            <div class="divider"></div>
            <ul>
                <li style="margin-bottom: 10px;"> <el-input size="small" v-model="changePasswordForm.password" type="password"  placeholder="请输入新密码"></el-input>
                </li>
                <li> <el-input size="small" v-model="changePasswordForm.password2" type="password"   placeholder="请重复密码"></el-input>
                </li>
            </ul>
        </template>
        <template v-else>
            <div class="divider"></div>
            <ul>
                <li><a > <img style="width: 18px;vertical-align: text-top;" src="@/assets/svg/mail.svg" >{{employee.email}}</a></li>
                <li><a > <img style="width: 18px;vertical-align: text-top;" src="@/assets/svg/phone.svg" >{{employee.phone}}</a></li>
            </ul>
        </template>

        <div class="divider"></div>
        <div class="dw-control">
            <el-button type="danger"  @click="changePassword()">修改密码</el-button>
            <el-button type="danger"  @click="handleChangeSection()">切换校区</el-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "profile",

        data() {
            return {
                path:'/user/base',
                title: '个人信息',
                loading: true,
                employee:{

                },
                showPasswordBox:false,
                changePasswordForm:{
                    password:'',
                    password2:'',
                },
                section_id:'',
            }
        },
        created() {
            this.handleCreate();
            this.section_id=this.$store.state.config.section.id;
            this.handleGetInit();
        },
        computed: {
            sections() {
                return this.$store.state.config.sections;
            },
        },
        methods:{
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'get_employee':
                        this.employee=data.employee;
                        break;
                    case 'change_user_password':
                        this.$message({
                            message: '修改密码成功',
                            type: 'success'
                        });
                        this.showPasswordBox=false
                        break;
                    case 'change_user_section':
                        this.button_loading = false;
                        break;
                }
            },
            handleGetInit(){
                this.$wApi.send(this.path, 'get_employee', {});
            },
            changePassword(){
                this.$Win.closeModal()
                this.router.push({path: '/changePassword'});
            },
            handleChangeSection(){
                this.$wApi.send(this.path, 'change_user_section', {
                    'section_id': this.section_id,
                });
            }
        }
    }
</script>

<style scoped>
    .dw-user-box {
        display: flex;
        flex-direction: row;
        justify-content:center;
        align-items:center;
        padding: 10px 15px;
        height:80px ;
    }
    .dw-user-box .u-img{
        flex: 0 0 80px;
    }
    .dw-user-box .u-img img{
        width: 80px;
        vertical-align: top;
        border-radius: 100%;
    }
    .dw-user-box .u-text {
        flex: 0 0 98px;
        padding-left:30px
    }
    .divider {
        height: 1px;
        margin: 9px 0;
        overflow: hidden;
        background-color: rgba(120, 130, 140, 0.13);
    }

    .dw-control{
        display: flex;
        flex-direction: row;
        justify-content:center;
        align-items:center;
        padding: 10px 15px;
    }
    .dw-control buttom{
        flex:1;
    }
    ul {
        margin: 0px 40px;
        padding: 0px; }
    ul li {
        list-style: none;
        line-height: 22px;
    }
</style>